// ** React Imports
import { useEffect, useState } from 'react'
import Image from 'next/image'
import { useRouter } from 'next/router'

// ui
import { Spin } from 'antd'
import { useTranslation } from 'src/utils/i18n'
import { getNotBindOrder } from 'src/@api/login'
import { appendSetupQuery, ensureBindOrderContext } from 'src/utils/resolveCurrentOrderId'
import { redirectIfShouldBuyPackage } from 'src/utils/chooseDeviceRedirect'

export const getHomeRoute = role => {
  if (role === 'client') return '/acl'
  else if (localStorage.getItem('currentMode') === 'Android-Cloud') return '/android/dashboard'
  else return '/dashboard'
}

/** 提到组件外，避免每次 render 换组件类型导致偶发挂载异常 */
const SelectPlatform = ({ t, router }) => {
  return (
    <>
      <h2 className='text-[24px] text-[#000] font-[Poppins] font-[600] leading-[36px] text-center mx-[15px] Mlg:mt-[60px] mt-[78px] mb-[37px]'>
        {t('Select the type of device want to monitoring')}
      </h2>

      <div className='max-w-[728px] grid grid-cols-1 smjs:grid-cols-2 gap-[30px] mx-[6px] smjs:mx-auto'>
        <div
          className='w-full h-[130px] cursor-pointer flex flex-col justify-center items-center [border:1px_solid_#0481FF] rounded-[10px]
            [background:linear-gradient(180deg,#ECF3FE_0%,#FDFEFF_100%)] hover:[background:linear-gradient(180deg,#D9E8FF_0%,#ECF3FE_100%)]'
          onClick={() => {
            window.localStorage.setItem('currentMode', 'iOS-Cloud')
            router.push(appendSetupQuery('/ios/setup'))
          }}
        >
          <Image src='/images/bind/ios.svg' alt='ios' width={41} height={48} className='w-[41px] h-[48px]' />
          <div className='flex justify-center items-center mt-[9px]'>
            <span className='text-[20px] text-[#222222] font-[Poppins] font-bold leading-[30px]'>{t('iOS')}</span>
            <Image src='/images/bind/arrow.svg' alt='arrow' width={6} height={12} className='w-[6.01px] h-[11.66px] ml-2' />
          </div>
        </div>

        <div
          className='w-full h-[130px] cursor-pointer flex flex-col justify-center items-center [border:1px_solid_#0481FF] rounded-[10px]
            [background:linear-gradient(180deg,#ECF3FE_0%,#FDFEFF_100%)] hover:[background:linear-gradient(180deg,#D9E8FF_0%,#ECF3FE_100%)]'
          onClick={() => {
            window.localStorage.setItem('currentMode', 'Android-Cloud')
            router.push(appendSetupQuery('/android/classification'))
          }}
        >
          <Image src='/images/bind/android.svg' alt='android' width={42} height={50} className='w-[42.31px] h-[50px]' />
          <div className='flex justify-center items-center mt-[9px]'>
            <span className='text-[20px] text-[#222222] font-[Poppins] font-bold leading-[30px]'>{t('Android')}</span>
            <Image src='/images/bind/arrow.svg' alt='arrow' width={6} height={12} className='w-[6.01px] h-[11.66px] ml-2' />
          </div>
        </div>
      </div>
    </>
  )
}

const Home = () => {
  const { t } = useTranslation('common')
  const router = useRouter()
  const [setupBlocked, setSetupBlocked] = useState(true)

  // 选平台前确保 bind 上下文（单张未绑单自动带 orderId）
  useEffect(() => {
    const init = async () => {
      const guard = await ensureBindOrderContext(window.location.search)
      if (guard.blocked) {
        setSetupBlocked(true)

        return
      }
      setSetupBlocked(false)

      if (guard.orderId) return

      try {
        const result = await getNotBindOrder()
        await redirectIfShouldBuyPackage(result)
      } catch (e) {
        // ignore — choose-device page still usable
      }
    }
    init()
  }, [])

  if (setupBlocked) {
    return (
      <div className='flex min-h-[240px] items-center justify-center'>
        <Spin size='large' />
      </div>
    )
  }

  return <SelectPlatform t={t} router={router} />
}

export default Home

